import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';

const EloHistoryChart = ({ recentChanges }) => {
  if (!recentChanges || recentChanges.length === 0) return null;

  const chartData = recentChanges.map(c => ({
    date: new Date(c.created_at).toLocaleDateString('sv-SE', { month: 'short', day: 'numeric' }),
    elo: c.elo_after,
    change: c.elo_change,
    won: c.won,
  }));

  return (
    <div className="elo-chart-container">
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData} margin={{ top: 10, right: 20, left: 10, bottom: 5 }}>
          <XAxis
            dataKey="date"
            tick={{ fill: '#a0a0b0', fontSize: 11 }}
            axisLine={{ stroke: '#2a2a3a' }}
            tickLine={false}
          />
          <YAxis
            domain={['auto', 'auto']}
            tick={{ fill: '#a0a0b0', fontSize: 11 }}
            axisLine={{ stroke: '#2a2a3a' }}
            tickLine={false}
            width={45}
          />
          <Tooltip
            contentStyle={{
              background: '#1a1a25',
              border: '1px solid #2a2a3a',
              borderRadius: '8px',
              color: '#fff',
              fontSize: '13px',
            }}
            formatter={(value, name) => {
              if (name === 'elo') return [value, 'ELO'];
              return [value, name];
            }}
            labelStyle={{ color: '#a0a0b0' }}
          />
          <ReferenceLine y={1000} stroke="#2a2a3a" strokeDasharray="3 3" />
          <Line
            type="monotone"
            dataKey="elo"
            stroke="#ff6b00"
            strokeWidth={2}
            dot={{ fill: '#ff6b00', r: 4, strokeWidth: 0 }}
            activeDot={{ fill: '#ff6b00', r: 6, stroke: '#fff', strokeWidth: 2 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EloHistoryChart;
